"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { PricingConfiguration } from "modules/common/model/models";

const PricingContext = createContext<PricingConfiguration | undefined>(
  undefined
);

export function PricingProvider({
  pricing,
  children,
}: {
  pricing: PricingConfiguration;
  children: ReactNode;
}) {
  return (
    <PricingContext.Provider value={pricing}>
      {children}
    </PricingContext.Provider>
  );
}

export function usePricingOverride() {
  return useContext(PricingContext);
}
